// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3c32v","footer":"ChangeClinic_footer__jBQEL"};